<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <ContractsRecordProducts
            ref="ContractsRecordProducts_products"
            type="products"
            @passProducts="passProducts"
            :onlyModal="true"
            mode="new"
            :record="record"
        />

        <div class="row">
            <div class="column medium-4 text-right float-right">
                <!-- <b-button v-if="mode == 'new'" type="is-light">
                    <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                        <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :disabled="!_.isNull(record.step2.customer_id) && activeStep == 1" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                    </b-tooltip>
                </b-button> -->

                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" to="/panel/creditfacturen/" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-8">
                <h1>{{ type == 'credit' ? 'Creditfactuur' : 'Factuur' }} aanmaken</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="activeStep">
                        <b-tab-item label="Klant">
                            <div class="column small-7" style="padding-left:0;">
                                <h1 class="title">Klant {{ record.customer_id ? 'gekoppeld' : 'aanmaken' }}</h1>
                            </div>

                            <div v-show="record.customer_id">
                                <CRUDCustomer
                                    ref="CRUDcustomer"
                                    :id="record.customer_id"
                                    :getCustomer="record.customer || {}"
                                    :record="record"
                                    :canRemoveCustomer="mode == 'new'"
                                    embedded_from="CreateInvoiceRecord"
                                    @removeCustomer="removeCustomer"
                                    :showAlert="true"
                                    @fullPageLoader="fullPageLoader"
                                    @linkCustomer="linkCustomer"
                                />
                            </div>
                            <div v-show="!record.customer_id">
                                <FindCustomer
                                    ref="findCustomer"
                                    :showAllCustomers="record.customer_id ? false : true"
                                    @linkCustomer="linkCustomer"
                                />
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Factuur" :key="updateKey">
                            <!-- <div v-if="user && user.role == 'pit' && mode == 'new'">
                                <b-field label="Organisatie (PIT)"
                                    :message="getError(errors, 'organisation')"
                                    :type="getType(errors, 'organisation', '')"
                                >
                                    <span>
                                        <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                            <option
                                                v-for="organisation in organisations"
                                                :value="organisation.id"
                                                :key="'organisatie_'+organisation.id"
                                                :disabled="organisation.invited === 0"
                                            >(ID: {{ organisation.id }}) {{ organisation.name }}{{ organisation.invited == 0 ? ' - Organisatie niet uitgenodigd!' : '' }}</option>
                                        </b-select>
                                    </span>
                                </b-field>
                                <br>
                            </div> -->

                            <div v-if="type == 'invoice'">
                                <h5>Betaling</h5>

                                <b-field label="Betaalmethode"
                                    :message="getError(errors, 'payment_type')"
                                    :type="getType(errors, 'payment_type', '')"
                                >
                                    <b-select placeholder="Maak een keuze" v-model="record.payment_type" expanded>
                                        <option value="incasso" :disabled="!user['organisation_incasso']">Automatische incasso{{ $store.state.env == 'demo' ? ' (uitgeschakeld in demo-omgeving)' : '' }}</option>
                                        <option value="manual">Handmatig</option>
                                    </b-select>
                                </b-field>

                                <b-field label="Factuurdatum"
                                    :message="getError(errors, 'date')"
                                    :type="getType(errors, 'date', '')"
                                >
                                    <b-datepicker
                                        placeholder="Klik om te selecteren"
                                        :nearby-selectable-month-days="true"
                                        icon="calendar-alt"
                                        icon-pack="fas"
                                        :min-date="moment(new Date()).startOf('day').toDate()"
                                        v-model="record.date"
                                    />
                                </b-field>

                                <br><br>
                            </div>

                            <b-message title="Creditfactuur versturen" type="is-info" aria-close-label="Sluiten" v-if="type == 'credit'">
                                De klant ontvangt de creditfactuur pas wanneer er een terugstorting aangemaakt is na het aanmaken van de creditfactuur, om te bevestigen dat dit bedrag teruggestort is. Je kan dus alvast een creditfactuur klaarzetten, en de creditfactuur versturen wanneer het bedrag teruggestort is.
                            </b-message>

                            <b-notification v-if="record.customer && record.customer.type == 'business'" type="is-info" aria-close-label="Sluiten">
                                <strong>Let op:</strong> getoonde prijzen zijn exclusief BTW (zakelijke klant)
                            </b-notification>

                            <b-notification v-if="record.customer && record.customer.type == 'foundation'" type="is-info" aria-close-label="Sluiten">
                                <strong>Let op:</strong> klant betreft een stichting, BTW wordt niet getoond op de factuur.
                            </b-notification>

                            <h5>Producten</h5>
                            <p v-if="type == 'credit'">
                                Geef aan welke bedragen er gewenst zijn om te crediteren. In het borg- en het totaal veld kan je via het vinkje aangeven welk type bedrag er gecrediteerd gaat worden.
                                Bedragen met borg zijn BTW-vrij, bedragen in veld "totaal" worden berekend met BTW.
                            </p>

                            <b-table
                                :data="record.products"
                                :striped="true"
                                :loading="loading"
                                :mobile-cards="true"
                                class="deposit-table"
                            >
                                <template>
                                    <b-table-column v-slot="product" field="name" label="Product" width="200">
                                        <b-input v-model="product.row.name"></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="btw" label="BTW %" width="100">
                                        <b-input type="number" min="0" max="100" v-if="product.row.totalType == 'price'" v-model="product.row.btw" :disabled="product.row.totalType == 'deposit'"></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="name" label="Aantal" width="100">
                                        <b-input type="number" min="1" v-model="product.row.amount"></b-input>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="deposit" label="Borg" width="100">
                                        <b-field :type="product.row.totalType == 'deposit' && type == 'credit' ? 'is-success' : 'is-light'">
                                            <b-input
                                                v-model="product.row.deposit"
                                                :icon-right="type == 'credit' ? 'check' : ''"
                                                :icon-right-clickable="type == 'credit'"
                                                min="0"
                                                :custom-class="type == 'credit' ? 'deposit-input' : ''"
                                                validation-message=""
                                                @icon-right-click="product.row.totalType = 'deposit'"
                                            />
                                        </b-field>
                                    </b-table-column>

                                    <b-table-column v-slot="product" field="price" label="Totaal" width="100">
                                        <b-field :type="product.row.totalType == 'price' && type == 'credit' ? 'is-success' : 'is-light'">
                                            <b-input
                                                v-model="product.row.price"
                                                :icon-right="type == 'credit' ? 'check' : ''"
                                                :icon-right-clickable="type == 'credit'"
                                                min="0"
                                                validation-message=""
                                                :custom-class="type == 'credit' ? 'deposit-input' : ''"
                                                @icon-right-click="product.row.totalType = 'price'"
                                            />
                                        </b-field>

                                        <!-- <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                        <span v-else-if="product.row.price > 0">&euro;&nbsp;{{ number_format(product.row.price * (product.row.amount || 1)) }}</span>
                                        <span v-else>-</span> -->
                                    </b-table-column>

                                    <b-table-column v-slot="product" numeric width="0">
                                        <b-tooltip label="Verwijder product uit creditfactuur" position="is-left">
                                            <b-button icon-right="times" type="is-danger" @click="removeProduct(product.row.id)"></b-button>
                                        </b-tooltip>
                                    </b-table-column>
                                </template>
                                <template #footer>
                                    <table class="text-right deposit-table-footer">
                                        <tr>
                                            <th>Subtotaal (ex. BTW)</th>
                                            <th width="150" v-if="(record.customer && record.customer.type == 'business') && type != 'credit'">€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}</th>
                                            <th width="150" v-else>€&nbsp;{{ !_.isNaN(subTotal) ? number_format(subTotal) : '-' }}</th>
                                        </tr>
                                        <tr>
                                            <th>Inbegrepen BTW:</th>
                                            <th width="150">€&nbsp;{{ !_.isNaN(btwTotal) ? number_format(btwTotal) : '-' }}</th>
                                        </tr>
                                        <tr v-if="record.customer && record.customer.type == 'business'" >
                                            <th class="text-info">Totaal (zakelijke klant):</th>
                                            <th width="150" v-if="type == 'credit'" class="has-text-danger">
                                                <span v-show="totalPrice > 0">- </span>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}
                                            </th>
                                            <th width="150" v-else>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice + btwTotal) : '-' }}</th>
                                        </tr>
                                        <tr v-else>
                                            <th>Totaal:</th>
                                            <th width="150" v-if="type == 'credit'" class="has-text-danger">
                                                <span v-show="totalPrice > 0">- </span>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice) : '-' }}
                                            </th>
                                            <th width="150" v-else>€&nbsp;{{ !_.isNaN(totalPrice) ? number_format(totalPrice + btwTotal) : '-' }}</th>
                                        </tr>
                                    </table>
                                </template>
                            </b-table>

                            <b-button @click="addProduct" type="is-primary" :outlined="type == 'invoice'">Product toevoegen</b-button>
                            <b-button @click="$refs['ContractsRecordProducts_products'].showModal(record.products)" type="is-primary" v-if="type == 'invoice'">Product zoeken</b-button>
                        </b-tab-item>
                    </b-tabs>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="column text-right">
                <div class="formfooter">
                    <b-button
                        type="is-success"
                        :loading="loading === true"
                        @click="++activeStep"
                        v-if="activeStep == 0"
                    >Volgende stap</b-button>
                    <b-button
                        type="is-success"
                        :loading="loading === true"
                        @click="createInvoice"
                        :disabled="!isValid"
                        v-else
                    >Opslaan en sluiten</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import CRUDCustomer from '@/vue/CRUDCustomer'
import FindCustomer from '@/vue/FindCustomer'
import ContractsRecordProducts from '@/vue/contracts/ContractsRecordProducts'
import filtersMixin from '@/mixins/filterMixins'
import toastMixins from '@/mixins/toastMixins'
import formvalidationMixin from '@/mixins/formvalidationMixin'

export default {
    name: 'CreateInvoiceRecord',

    mixins: [filtersMixin, toastMixins, formvalidationMixin],

    components: {
        CRUDCustomer,
        FindCustomer,
        ContractsRecordProducts
    },

    data() {
        return {
            type: null,
            updateKey: 0,
            activeStep: 0,
            mode: 'new',
            record: {
                customer_id: null,
                customer: null,
                products: [],
                organisation: null,
                date: null,
                payment_type: null
            },
            loading: false,
            errors: {},

            // canRemoveCustomer: true // replaced
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        isValid() {
            let valid = true

            if(_.isNaN(this.subTotal) || _.isNaN(this.btwTotal) || _.isNaN(this.totalPrice)){
                valid = false
            }
            if(!this.record.products.length){
                valid = false
            }

            return valid
        },

        subTotal() {
            if(!_.has(this, 'record.products')) return false;
            let price = this.totalPrice - this.btwTotal

            return price
        },

        btwTotal() {
            if(!_.has(this, 'record.products')) return false;
            let price = 0

            _.each(this.record.products, (product) => {
                if(this.record && _.has(this.record, 'customer') && this.record.customer && this.record.customer.type == 'business'){
                    if(this.type == 'credit') {
                        price += (product.totalType == 'price' ? (product.price - (product.price / (1 + Number(product.btw) / 100))) : 0) * product.amount
                    } else {
                        price += (product.price * product.btw / 100) * product.amount
                    }
                } else {
                    if(this.type == 'credit') {
                        if(product.totalType == 'price'){
                            price += (product.price - (product.price / (1 + Number(product.btw) / 100))) * product.amount
                        }
                    } else {
                        // price += (product.price * product.btw / 100) * product.amount
                        price += (product.price - (product.price / (1 + Number(product.btw) / 100))) * product.amount
                    }
                }
            })

            return price
        },

        totalPrice() {
            if(!_.has(this, 'record.products')) return false;
            let price = 0

            _.each(this.record.products, (product) => {
                if(this.type == 'credit') {
                    if(this.record && _.has(this.record, 'customer') && this.record.customer &&this.record.customer.type == 'business'){
                        price += (product.totalType == 'price' ? product.price : product.deposit) * product.amount
                    } else {
                        price += product.totalType == 'price' ? (product.price * product.amount) : (product.deposit * product.amount)
                    }
                } else {
                    if(this.record && _.has(this.record, 'customer') && this.record.customer &&this.record.customer.type == 'business'){
                        // const btw = (product.price * product.btw / 100) * product.amount
                        price += (parseFloat(product.price) + parseFloat(product.deposit)) * product.amount
                    } else {
                        price += (product.price * product.amount) + (product.deposit * product.amount)
                    }
                }
            })

            return price
        }
    },

    created() {
        if (this.user.organisation) {
            this.record.organisation = this.user.organisation
        }

        if (this.$route.name == 'CreditInvoiceRecord') {
            this.type = 'credit'
            this.fetchInvoiceProducts()
        } else if (this.$route.name == 'CreateInvoiceRecord') {
            this.type = 'invoice'
            this.record.date = moment(new Date()).startOf('day').toDate() // select today

            if ((_.has(this.$route.query, 'type') && this.$route.query.type == 'los')) {
                if (_.has(this.$route.query, 'products')) {
                    // Convert to string and then split
                    const products = String(this.$route.query.products)
                    const productIds = products.split(',')

                    // Initialize empty products array
                    this.$set(this.record, 'products', [])

                    // Fetch each product sequentially
                    productIds.forEach(productId => {
                        this.fetchProduct(productId)
                    })
                } else {
                    // No products to fetch. Add a default one.
                    this.addProduct()
                }
            } else {
                // No products to fetch. Add a default one.
                this.addProduct()
            }
        } else {
            // No products to fetch. Add a default one.
            this.addProduct()
        }
    },

    mounted() {
        const routeQuery = this.$route.query

        if(Object.keys(routeQuery).length){
            if(_.has(routeQuery, 'customer')){
                this.record.customer_id = routeQuery.customer
                this.activeStep = 1

                this.$refs['CRUDcustomer'].fetchCustomerWithID(parseInt(routeQuery.customer))
            }
        }
    },

    methods: {
        fetchInvoiceProducts() {
            this.loading = true
            const routeQuery = this.$route.query
            if(!routeQuery.invoice) return false;

            axios.get('/api/invoices/'+routeQuery.invoice, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.record.organisation = response.data.organisation

                if(_.has(routeQuery, 'products')){
                    // Convert to string and then split
                    const products = String(routeQuery.products)
                    const productIds = products.split(',')
                    const depositProducts = []
                    const addedProductIds = new Set()

                    _.each(productIds, (productId) => {
                        let findProduct = null

                        findProduct = _.find(response.data.invoice_products, (x) => { return x.id == Number(productId) })

                        if (!findProduct) {
                            findProduct = _.find(response.data.contract_products, (x) => { return x.product == Number(productId) })
                        }

                        if (findProduct) {
                            const productIdentifier = findProduct.id || findProduct.product

                            // Only add if we haven't seen this product ID before
                            if (!addedProductIds.has(productIdentifier)) {
                                // If deposit set 'totalType': 'deposit' else 'price'.
                                findProduct.totalType = findProduct.deposit > 0 ? 'deposit' : 'price'
                                findProduct.amount = _.isNull(findProduct.amount) ? 1 : findProduct.amount

                                depositProducts.push(findProduct)
                                addedProductIds.add(productIdentifier)
                            }
                        } else {
                            console.log('Product not found', productId)
                        }
                    })

                    this.$set(this.record, 'products', [...depositProducts])
                } else {
                    // Deduplicate invoice products by ID
                    const uniqueProducts = _.uniqBy(response.data.invoice_products, 'id')
                    this.$set(this.record, 'products', uniqueProducts)
                }
            }).catch((error) => {
                console.log(error)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.$router.go(-1)
            }).then(() => {
                this.loading = false
            })
        },

        fetchProduct(id = false) {
            id = id || this.$route.query.product
            if (!id) return false

            this.loading = true

            axios.get('/api/products/'+id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                let products = [...this.record.products] // Create a copy of existing products
                this.record.organisation = response.data.organisation

                _.assign(response.data, {
                    amount: 1,
                    type: 'product',
                    contract: null,
                    once: 1,
                    product: response.data.id,
                    totalType: 'price'
                })

                products.push(response.data)
                this.$set(this.record, 'products', products)
            }).catch((error) => {
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                this.$router.go(-1)
            }).then(() => {
                this.loading = false
            })
        },

        passProducts(obj) {
            // Remove first product if it has no name and zero price to get replaced by a new relevant product.
            if (obj.records.length > 0 &&
                (!obj.records[0].name?.length) &&
                obj.records[0].price === '0.00') {
                obj.records.shift()
            }

            // Map products directly instead of mutating with _.each
            const products = obj.records.map(product => ({
                ...product,
                amount: product.amount || 1,
                type: 'product',
                contract: null,
                once: 1,
                product: product.id,
                totalType: 'price'
            }))

            this.$set(this.record, 'products', products)
        },

        removeProduct(productId){
            const products =_.remove(this.record.products, (x) => {
                return x.id != productId
            })

            this.$set(this.record, 'products', products)
        },

        createInvoice() {
            if(_.isNull(this.record.customer_id) || !_.has(this.record, 'customer_id')){
                this.showError('Er is geen klant gekoppeld.')
                this.activeStep = 0
                return false;
            }

            this.loading = true

            // Has this invoice a credit_of?
            this.record.credit_of = _.has(this.$route.query, 'invoice') ? this.$route.query.invoice : null

            // Slice out products without a name.
            let theProducts = _.filter(this.record.products, (x) => { return !!x.name.length })

            if(!theProducts.length){
                this.showError('Geen producten, vul ook de naam van het product in.')
                this.loading = false
                return;
            }

            // Set organisation id to all products
            _.each(theProducts, (product) => {
                _.assign(product, {
                    'organisation': this.record.organisation
                })
            })

            this.record.products = theProducts

            axios.post('/api/generate-invoice/'+this.type, this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data.id){
                    this.$router.push({name: 'InvoicesRecord', params: {type: this.type, id: response.data.id}})
                }
            }).catch((error) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                } else if (_.has(error, 'response.data.error')){
                    this.showError('Opslaan mislukt - ' + error.response.data.error, 5000)
                } else {
                    this.$buefy.toast.open({
                        message: 'Opslaan mislukt - Onvoldoende of onjuiste gegevens.',
                        type: 'is-danger'
                    })
                }

                console.error('[❌] Error while validating the product:', error)
                this.errors = {...error.response.data.errors}
                this.loading = false
            }).then(() => {
                this.loading = false
            })
        },

        addProduct(){
            const product = {
                id: Math.floor(100000000 + Math.random() * 900000000),// random to delete
                amount: 1,
                btw: '21.00',
                deposit: '0.00',
                name: '',
                price: '0.00',
                once: 1,
                organisation: this.record.organisation,
                type: 'product',
                product: null,
                totalType: 'price'
            }

            this.record.products.push(product)
        },

        linkCustomer(customer){
            if(!customer) return

            Vue.set(this.record, 'customer', {...customer})
            Vue.set(this.record, 'customer_id', customer.id)
            Vue.set(this.record, 'organisation', customer.organisation)
        },

        removeCustomer(){
            Vue.set(this.record, 'customer_id', null)
            Vue.set(this.record, 'customer', null)
            Vue.set(this.record, 'organisation', null)

            this.$refs.findCustomer.searchCustomer()
        },

        fullPageLoader(value){
            this.loading = value
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },
    }
}
</script>